import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  counter: {
    display: 'block',
    textAlign: 'right',
    color: theme.palette.grey[600],
  },
}));
